<template>
  <b-modal id="profile-modal" ref="modal" :title="title" @hidden="onClose" @show="onShow" size="lg">
    <ValidationObserver ref="profileForm" tag="form" @submit.prevent="onSubmit" id="profileForm">
      <template v-if="isEdited === false">
        <div class="section-title">Dane Konta:</div>
        <b-form-group label-cols-lg="3" label="Adres email:" label-for="email" label-align-lg="right">
          <ValidationProvider name="email" rules="required|email" v-slot="validationContext">
            <b-form-input
              id="email"
              v-model="form.email"
              type="text"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <b-form-group label-cols-lg="3" label="Uprawnienia:" label-for="role" label-align-lg="right">
          <ValidationProvider name="role" rules="required" v-slot="validationContext">
            <b-form-select v-model="form.role" :options="avaibleRole"></b-form-select>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <b-form-group label-cols-lg="3" label="Hasło:" label-for="password" label-align-lg="right">
          <ValidationProvider name="password" rules="required|min:8" v-slot="validationContext">
            <b-form-input
              id="password"
              v-model="form.password"
              type="password"
              :state="getValidationState(validationContext)"
            ></b-form-input>
            <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
          </ValidationProvider>
        </b-form-group>
        <hr />
      </template>
      <div class="section-title">Dane Profilu:</div>
      <b-form-group label-cols-lg="3" label="Imię:" label-for="firstname" label-align-lg="right">
        <ValidationProvider name="firstname" rules="required|max:191" v-slot="validationContext">
          <b-form-input
            id="firstname"
            v-model="form.firstname"
            type="text"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>
      <b-form-group label-cols-lg="3" label="Nazwisko:" label-for="lastname" label-align-lg="right">
        <ValidationProvider name="lastname" rules="required|max:191" v-slot="validationContext">
          <b-form-input
            id="lastname"
            v-model="form.lastname"
            type="text"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>
      <b-form-group label-cols-lg="3" label="Telefon:" label-for="phone" label-align-lg="right">
        <ValidationProvider name="phone" rules="required|max:24" v-slot="validationContext">
          <b-form-input
            id="phone"
            v-model="form.phone"
            type="text"
            :state="getValidationState(validationContext)"
          ></b-form-input>
          <b-form-invalid-feedback>{{ validationContext.errors[0] }}</b-form-invalid-feedback>
        </ValidationProvider>
      </b-form-group>
    </ValidationObserver>
    <template v-slot:modal-footer="{cancel}">
      <b-button size="md" variant="primary" type="submit" form="profileForm">Zapisz</b-button>
      <b-button size="md" variant="outline-danger" @click="cancel()">Anuluj</b-button>
    </template>
  </b-modal>
</template>

<script>
// import userManager from "@/services/userManager.service";
import EmployeesService from "@/services/employees.service";

export default {
  name: "ModalProfile",
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      avaibleRole: EmployeesService.avaibleRole,
      form: {
        firstname: "",
        lastname: "",
        phone: "",
        email: "",
        password: "",
        role: ""
      }
    };
  },
  computed: {
    title() {
      return this.$_.isEmpty(this.user) === false
        ? "Edytuj pracownika: " + this.user.email
        : "Dodaj nowego pracownika";
    },
    isEdited() {
      return this.$_.isEmpty(this.user) === false;
    }
  },
  methods: {
    getValidationState({ validated, valid = null }) {
      return validated ? valid : null;
    },
    onShow() {
      if (this.isEdited) {
        this.form.firstname = this.user.firstname;
        this.form.lastname = this.user.lastname;
        this.form.phone = this.user.phone;
      }
    },
    onClose() {
      this.$_.each(this.form, (value, key) => {
        this.form[key] = "";
      });
      this.form.role = "employee";
      this.$emit("onClose");
    },
    onSubmit() {
      this.$refs.profileForm.validate().then(success => {
        if (!success) {
          return;
        }
        this.$Progress.start();
        if (this.isEdited) {
          //-- EDITED
          EmployeesService.update(this.user.id, this.form)
            .then(data => {
              this.$_.each(data, (v, k) => {
                this.user[k] = v;
              });
              this.$nextTick(() => {
                this.$bvModal.hide("profile-modal");
              });
            })
            .catch(error => {
              this.$refs.profileForm.setErrors(error.response.data.fields);
            });
        } else {
          //-- CREATE NEW
          EmployeesService.create(this.form)
            .then(data => {
              this.$emit("onSubmit", data);
              this.$nextTick(() => {
                this.$bvModal.hide("profile-modal");
              });
            })
            .catch(error => {
              this.$refs.profileForm.setErrors(error.response.data.fields);
            });
        }
      });
    }
  }
};
</script>